import { SVGInterface } from "../../interface";

const Layers = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M11.99 19.005L4.62 13.275L3 14.535L12 21.535L21 14.535L19.37 13.265L11.99 19.005ZM12 16.465L19.36 10.735L21 9.46497L12 2.46497L3 9.46497L4.63 10.735L12 16.465ZM12 4.99497L17.74 9.46497L12 13.935L6.26 9.46497L12 4.99497Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Layers;
